import { add, replace } from '@avangard/utils/array';

import { $editGrantsStore, addGrantEvent, enableEditGrantsEvent, resetEditGrantsEvent } from './';

$editGrantsStore
    .on(addGrantEvent, (state, payload) => {
        let grants = [...state.grants];

        const idx = grants.findIndex(
            grant =>
                grant.id === payload.id &&
                grant.category === payload.category &&
                grant.action === payload.action,
        );

        if (idx > -1) {
            grants = replace(grants, payload, idx);
        } else {
            grants = add(grants, payload);
        }

        return {
            ...state,
            grants,
        };
    })
    .on(enableEditGrantsEvent, state => ({ ...state, enabled: true }))
    .reset(resetEditGrantsEvent);
